import React from "react";
import styled from "styled-components";
import { Locale } from "@linkfluence/models/locale";
import Panel from "@ui-kit/popover/panel";
import Autocomplete from "@radarly/components/filterbar/panels/autocomplete";
import { useFilterbarChoices } from "@radarly/core/filters/use-cases";
import { useCurrentUserLocale } from "@radarly/core/user/use-cases";
import { tr } from "@radarly/i18n";
import { Clause } from "@radarly/models/clause";
import { isClauseEmpty } from "@radarly/models/clause/is";
import { refineClauseWithInnerClause } from "@radarly/models/clause/refiner";
import { transformClauseFromField } from "@radarly/models/clause/transformer";
import { FullFacet } from "@radarly/models/facets";
import { Choice, Status } from "@radarly/models/filters";
import { getNextClauseFromStatusAndValue } from "./clause";

interface IProps {
  clause: Clause;
  facet: FullFacet;
  setClause: (clause: Clause) => void;
  locale?: Locale;
  hasTitle?: boolean;
  onApply: () => void;
  onCancel?: () => void;
  visible?: boolean;
  validateLabel?: string;
  className?: string;
}

const Root = styled.div`
  width: 702px;
  height: 150px;
  display: table;
`;

const RadarlyFilterbarPanelsAutocomplete = ({
  setClause,
  clause,
  facet,
  hasTitle,
  onApply,
  onCancel,
  visible,
  validateLabel,
  className,
}: IProps) => {
  const locale = useCurrentUserLocale();

  const onStatusChange = (choice: Choice, status: Status) => {
    setClause(
      getNextClauseFromStatusAndValue(clause, facet, choice.id, status)
    );
  };
  const { orderedChoices } = useFilterbarChoices(clause, facet);

  const onClear = () => {
    setClause(
      refineClauseWithInnerClause(
        clause,
        transformClauseFromField(
          {
            [facet.id]: [],
          },
          facet.custom ? [facet.id] : []
        )
      )
    );
  };
  return (
    <Panel
      allowOverflow
      locale={locale}
      onClear={onClear}
      hasTitle={hasTitle}
      title={tr(locale, "FILTERBAR::PANEL::FILTERBY", {
        filter: facet.label,
      })}
      onApply={onApply}
      onCancel={onCancel}
      disabled={onCancel ? isClauseEmpty(clause) : false}
      validateLabel={validateLabel}
      className={className}
    >
      <Root>
        <Autocomplete
          choices={orderedChoices}
          onSelect={onStatusChange}
          placeholder={tr(
            locale,
            "FILTER_PANEL::SEARCH_PLACEHOLDER::" + facet.id
          )}
          noOptionMessage={tr(
            locale,
            "FILTERBAR::PANEL::AUTOCOMPLETE::NOFILTER"
          )}
          freeText
          visible={visible}
        />
      </Root>
    </Panel>
  );
};

export default RadarlyFilterbarPanelsAutocomplete;
